module.exports = __webpack_public_path__ + "img/logoAPHP_ParisCite.91818d63.png";